/* ss-main-product.js — gallery scroll-snap + thumbnail đồng bộ + reveal on scroll
   Không phụ thuộc thư viện ngoài. Dùng custom element theo đúng lối Dawn 15.5. */
(function () {
  'use strict';

  function initGallery(root) {
    var track = root.querySelector('.ss-gallery__track');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.ss-gallery__thumb'));
    var prev = root.querySelector('.ss-gallery__nav--prev');
    var next = root.querySelector('.ss-gallery__nav--next');
    if (!slides.length) return;

    var current = 0;

    function goTo(i) {
      current = Math.max(0, Math.min(i, slides.length - 1));
      track.scrollTo({ left: slides[current].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }

    function markActive(i) {
      thumbs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    // Đồng bộ thumbnail theo vị trí cuộn thật (không đoán theo click)
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio > 0.6) {
            current = slides.indexOf(e.target);
            markActive(current);
          }
        });
      }, { root: track, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.dataset.goto, 10) || 0); });
    });
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    // Điều hướng bàn phím khi track được focus
    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
    });

    markActive(0);
  }

  function initReveal() {
    var els = document.querySelectorAll('.ss-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function boot() {
    document.querySelectorAll('.ss-gallery').forEach(initGallery);
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: section được render lại thì khởi tạo lại
  document.addEventListener('shopify:section:load', function (e) {
    var g = e.target.querySelector('.ss-gallery');
    if (g) initGallery(g);
  });
})();
